import React, { useState } from 'react';
import './index.css';
import Input from 'common/components/Input';
import { CheckLine } from './components/CheckLine';
import styled from '@emotion/styled';
import SelectEl from 'common/components/Select';
import Button from 'common/components/Button';
import { companySizeData, industryData, workspaceTypeData } from 'common/data/registrationDropdowns';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'common/context/AuthContext';

const RegistrationInfoWrapper = styled.div`
  padding: 50px 86px 50px 86px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid ${(props) => props.theme.colors.primaryColor};
  border-radius: 20px;
  max-width: 570px;
`;

export default function RegistrationPage() {
  const location = useLocation();
  const ownerId = location.state?.ownerId || 0;
  console.log(ownerId);
  const { updateCompanyId } = useAuth();
  const [name, setName] = React.useState<string>('');
  const [workspace, setWorkspace] = useState<number>(0);
  const [industry, setIndustry] = useState<number>(0);
  const [specialization, setSpecialization] = useState<number>(0);
  const [companySize, setCompanySize] = useState<number>(0);
  const [nameError, setNameError] = useState<boolean>(false);
  const [workspaceError, setWorkspaceError] = useState<boolean>(false);
  const [industryError, setIndustryError] = useState<boolean>(false);
  const [specializationError, setSpecializationError] = useState<boolean>(false);
  const [companySizeError, setCompanySizeError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.trim() !== '') setNameError(false);
    setName(e.target.value);
  };
  const handleWorkSpaceChange = (e) => {
    if (e.target.value !== 0) setWorkspaceError(false);
    setWorkspace(e.target.value);
  };
  const handleIndustryChange = (e) => {
    setSpecialization(0);
    if (e.target.value !== 0) setIndustryError(false);
    setIndustry(e.target.value);
  };
  const handleSpecializationChange = (e) => {
    if (e.target.value !== 0) setSpecializationError(false);
    setSpecialization(e.target.value);
  };
  const handleCompanySizeChange = (e) => {
    if (e.target.value !== 0) setCompanySizeError(false);
    setCompanySize(e.target.value);
  };

  function checkError() {
    let hasError = false;
    if (name.trim() === '') {
      setNameError(true);
      hasError = true;
    } else {
      setNameError(false);
    }
    if (workspace === 0) {
      setWorkspaceError(true);
      hasError = true;
    } else {
      setWorkspaceError(false);
    }
    if (industry === 0) {
      setIndustryError(true);
      hasError = true;
    } else {
      setIndustryError(false);
    }
    if (specialization === 0) {
      setSpecializationError(true);
      hasError = true;
    } else {
      setSpecializationError(false);
    }
    if (companySize === 0) {
      setCompanySizeError(true);
      hasError = true;
    } else {
      setCompanySizeError(false);
    }
    return hasError;
  }

  const sendRequest = async () => {
    // create form data
    const workspaceLabel = workspaceTypeData.find((el) => el.value === workspace)?.label;
    const industryLabel = industryData.find((el) => el.value === industry)?.label;
    const specializationLabel = industryData[industry - 1]?.specialization.find((el) => el.value === specialization)?.label;
    const companySizeLabel = companySizeData.find((el) => el.value === companySize)?.label;
    
    const formData = new FormData();
    formData.append('companyName', name);
    formData.append('ownerId', ownerId.toString());
    formData.append('companyType', workspaceLabel);
    formData.append('industry', industryLabel);
    formData.append('country', specializationLabel);
    formData.append('companySize', companySizeLabel);
    // send request
    const response = await fetch('https://api-workspace.astin.net/api/user/registration', {
      method: 'POST',
      body: formData,
    });
    console.log(response.status);
    if (response.status === 200) {
      setLoading(false);
      const json:string = await response.json();
      updateCompanyId(json);
      navigate('/contacts');
      // redirect to main page
    } else {
      setLoading(false);
      // show error
    }
    
  };

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let hasError = false;
    
    hasError = checkError();
    if (hasError) {
      return;
    }
    setLoading(true);
    sendRequest();
  };
  if (!ownerId || ownerId == 0) {
    return (
      <Navigate to={'/login'} replace state={{ from: '/registration' }} />
    );
  }
  return (
    <section className='registration-section'>
      <div className='registration-wrapper'>
        <RegistrationInfoWrapper className='registration-info-wrapper'>
          <h4>
            Працюйте віддалено з максимальною ефективністю
          </h4>
          <p>
            З ASTIN Messenger можна проводити безпечні зустрічі у високій якості просто з поштової скриньки або календаря
          </p>
          <h3>
            Робіть більше з ASTIN Workspace
          </h3>
          <CheckLine><p>{"Персоналізована електронна адреса з вашим доменним ім'ям"}</p></CheckLine>
          <CheckLine><p>Робота в хмарі без необхідності встановлювати додаткове ПЗ</p></CheckLine>
          <CheckLine><p>Безкоштовне користування протягом 14 днів; потім плата стягуватиметься щомісяця</p></CheckLine>
          <CheckLine><p>Розширені функції адміністрування й безпеки</p></CheckLine>
          <CheckLine><p>Цілодобова підтримка без вихідних</p></CheckLine>
        </RegistrationInfoWrapper>
        <form onSubmit={handleFormSubmit} className='registration-form'>
          <h2 className='registration-title'>Створити акаунт</h2>
          <div className='registration-line-wrapper'>
            <p className='registration-line-label'>Назва акаунту</p>
            <Input error={nameError} value={name} onChange={handleNameChange} placeholder='Назва' props={{ maxLength: 100 }} />
          </div>
          <div className='registration-line-wrapper'>
            <p className='registration-line-label'>Тип робочого простору</p>
            <SelectEl error={workspaceError} placeholder='Оберіть тип робочого простору' value={workspace} onChange={handleWorkSpaceChange} data={workspaceTypeData} />
          </div>
          <div className='registration-line-wrapper'>
            <p className='registration-line-label'>Галузь</p>
            <SelectEl error={industryError} placeholder='Оберіть галузь' value={industry} onChange={handleIndustryChange} data={industryData} />
          </div>
          <div className='registration-line-wrapper'>
            <p className='registration-line-label'>Спеціалізація</p>
            <SelectEl error={specializationError} disabled={industry === 0 ? true : false} placeholder='Оберіть спеціалізацію' value={specialization} onChange={handleSpecializationChange} data={industryData[industry - 1]?.specialization || []} />
          </div>
          <div className='registration-line-wrapper'>
            <p className='registration-line-label'>Розмір компанії</p>
            <SelectEl error={companySizeError} placeholder='Оберіть розмір компанії' value={companySize} onChange={handleCompanySizeChange} data={companySizeData} />
          </div>
          <Button loading={loading} className='registration-button' type='submit' primary label='ДАЛІ'></Button>
        </form>
      </div>
    </section>
  );
}

